import compose from 'lodash/fp/compose';

import { canAdd, canUpdate, paginate, selectable } from '../plugins';
import groupsApi from '../../firebase/groups';
import PluggableModule from '../pluggable';

const groups = new PluggableModule('group');

groups.extend({
  namespaced: true,
  actions: {
    async addGroup({ commit }, data) {
      commit(groups.con.GROUP_SUBMIT_INIT);
      try {
        const ref = await groupsApi.add(data);
        commit(groups.con.GROUP_CREATED, ref.id);
        commit(groups.con.GROUP_SUBMIT_DONE);
      } catch (error) {
        commit(groups.con.GROUP_SUBMIT_DONE);
        throw error;
      }
    },
    async updateGroup({ commit }, data) {
      commit(groups.con.GROUP_SUBMIT_INIT);
      try {
        await groupsApi.update(data);
        commit(groups.con.GROUP_SUBMIT_DONE);
      } catch (error) {
        commit(groups.con.GROUP_SUBMIT_DONE);
        throw error;
      }
    }
  }
});

const hop = compose(
  canAdd(),
  canUpdate(),
  paginate('groups'),
  selectable(groupsApi, false)
);

export default hop(groups);
